<a [attr.disabled]="disabled ? true : null" [class]="classNames" (click)="showLogClick($event)" href="#">
  <span>Show log</span>
  @if (showIcon) {
    <ep-svg-icon icon="bell"></ep-svg-icon>
  }
</a>

<ng-template #logTemplate let-c="close">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="c()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    <app-change-log-search #search [entities]="entities">
      <app-change-log-viewer [items]="search.items" [users]="search.users"></app-change-log-viewer>
    </app-change-log-search>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c()">Close</button>
  </div>
</ng-template>
